//@ts-check

/**
 * @type {import("./types").isRelativeType}
 */
export default (function (path) {
  return path.indexOf('./') === 0 || path.indexOf('../') === 0;
});